import React from 'react'
import MaterialSymbol from '../material-symbol'

const HelpOutline = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="help_outline" {...props} />
))

HelpOutline.displayName = 'HelpOutline'

export default HelpOutline
